// CALCULATION OF PAYOUT
// ---------------------
//


export function payout(L, AP, EP, CP, AL) {
    // L: loss
    // AP: attachment point
    // EP: exhaustion point
    // CP: ceding percentage
    // AL: aggregate limit
    if (L <= AP) {
        return 0
    } else if (L >= EP) {
        return AL
    } else {
        return (L - AP) * CP / 100
    }
}

